var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 2.83333H14.5667C14.275 1.49167 13.1083 0.5 11.7083 0.5C10.3083 0.5 9.14166 1.49167 8.85 2.83333H0.625V4H8.85C9.14166 5.34167 10.3083 6.33333 11.7083 6.33333C13.1083 6.33333 14.275 5.34167 14.5667 4H16.9583V2.83333ZM11.7083 5.16667C10.7167 5.16667 9.95833 4.40833 9.95833 3.41667C9.95833 2.425 10.7167 1.66667 11.7083 1.66667C12.7 1.66667 13.4583 2.425 13.4583 3.41667C13.4583 4.40833 12.7 5.16667 11.7083 5.16667Z",
    fill: "#0061ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 12.1665H3.01667C3.30833 13.5082 4.475 14.4998 5.875 14.4998C7.275 14.4998 8.44166 13.5082 8.73333 12.1665H16.9583V10.9998H8.73333C8.44166 9.65817 7.275 8.6665 5.875 8.6665C4.475 8.6665 3.30833 9.65817 3.01667 10.9998H0.625V12.1665ZM5.875 9.83317C6.86666 9.83317 7.625 10.5915 7.625 11.5832C7.625 12.5748 6.86666 13.3332 5.875 13.3332C4.88333 13.3332 4.125 12.5748 4.125 11.5832C4.125 10.5915 4.88333 9.83317 5.875 9.83317Z",
    fill: "#0061ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default ForwardRef;